import { render, staticRenderFns } from "./SuperAdminDashboard.vue?vue&type=template&id=463a4f02&scoped=true"
import script from "./SuperAdminDashboard.vue?vue&type=script&lang=js"
export * from "./SuperAdminDashboard.vue?vue&type=script&lang=js"
import style0 from "./SuperAdminDashboard.vue?vue&type=style&index=0&id=463a4f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a4f02",
  null
  
)

export default component.exports